import { useEffect, useState, useRef } from 'react'
// @ts-ignore
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useTransition, animated, config } from '@react-spring/web'
import styled from 'styled-components'
import { RxClipboardCopy } from 'react-icons/rx'
import { FiCheck } from 'react-icons/fi'

const CopyUrl = ({
  title,
  text,
  url,
  locale,
  buttonColor,
  textButtonColor,
  inverted,
}: {
  title: string
  text: string
  url: string
  locale: 'fr' | 'de'
  buttonColor: string
  textButtonColor: string
  inverted: boolean
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [copied, setCopied] = useState(false)
  const timeout = useRef<NodeJS.Timeout | null>(null)
  const transitions = useTransition(copied && isMobile, {
    from: { opacity: 0, translateY: -10, translateX: '-50%' },
    enter: { opacity: 1, translateY: 0, translateX: '-50%' },
    leave: { opacity: 0, translateY: -10, translateX: '-50%' },
    delay: 200,
    config: config.molasses,
  })

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffect(() => {
    if (copied) {
      timeout.current = setTimeout(() => {
        setCopied(false)
      }, 3000)

      // window.dataLayer = window.dataLayer || []
      // window.dataLayer.push({
      //   event: 'Interactions',
      //   event_action: 'copyurl',
      //   event_label: `url:${url}`,
      // })
    }
  }, [copied])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)

      if (timeout.current) {
        clearTimeout(timeout.current)
      }
    }
  }, [])

  return (
    <Container>
      <HeaderContent>
        <Title>{title}</Title>
      </HeaderContent>
      <div>
        <InputContainer>
          <Input type='text' defaultValue={url} />
          <CopyToClipboard
            text={url}
            onCopy={() => {
              setCopied(true)
            }}
          >
            <Button
              style={{ borderRadius: 0 }}
              textColor={textButtonColor}
              color={buttonColor}
            >
              {copied ? <FiCheck /> : <RxClipboardCopy />}
              {!isMobile && (
                <div style={{ marginLeft: '.5em' }}>
                  {copied ? `Copié!` : 'Copier'}
                </div>
              )}
              {transitions(
                (style, item) =>
                  item && (
                    <LabelContainer style={style}>
                      <div>Copié!</div>
                    </LabelContainer>
                  )
              )}
            </Button>
          </CopyToClipboard>
        </InputContainer>
      </div>
      <Text>{text}</Text>
    </Container>
  )
}

CopyUrl.defaultProps = {
  locale: 'de',
  url: window.location.href,
  inverted: false,
}

const Container = styled.div`
  font-family: var(--font-sans-serif);
  position: relative;
`
const InputContainer = styled.div`
  width: 100%;
  margin: 0.35rem 0;
  display: flex;
  align-items: stretch;
  font-size: 1em;
  position: relative;
`

const Title = styled.div`
  font-weight: 400;
  font-size: 1em;
  line-height: 1.2;
  color: ${({ theme }) => theme.colorGreyDark};
`

const Text = styled.div`
  font-size: 1.6rem;
  line-height: 1.2em;
`
const HeaderContent = styled.div`
  position: relative;
  margin-bottom: 1rem;
`
const LabelContainer = styled(animated.div)`
  background-color: var(--site-background);
  z-index: 2;
  position: absolute;
  top: -32px;
  left: 50%;
  padding: 0.5rem 1rem;
  font-size: 0.8em;
  color: ${({ theme }) => theme.colorText};

  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 5px 0 5px;
    border-color: var(--site-background) transparent transparent transparent;
  }
`
const Input = styled.input`
  font-family: var(--font-sans-serif);
  color: var(--brandblue-bright-3);
  padding: 1rem 1rem;
  border: none;
  outline: none;
  width: 100%;
  font-size: 1em;
  border-radius: 0;
  margin: 0;
  appearance: none;
  background-color: ${({ theme }) => theme.colorGreyLight};
`
const Button = styled.button<{ color: string; textColor: string }>`
  position: relative;
  font-family: var(--font-sans-serif);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.color};
  color: ${(props) => props.textColor};
  border: none;
  outline: none;
  font-size: 1em;
  padding: 0.5rem 2rem;
  cursor: pointer;
  margin: 0;
  min-width: 40px;
  border-radius: 12px;

  svg {
    flex-shrink: 0;
  }
`

export default CopyUrl
